// @ts-nocheck 3fdb6566
import * as actionTypes from './permanentBorderActionTypes';

const setComponent = (compRef) => ({
  type: actionTypes.SET_COMPONENT,
  compRef,
});

export { setComponent };
